/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE:  you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import * as tslib_1 from "tslib";
import { Base, markType } from "igniteui-react-core";
import { Size } from "igniteui-react-core";
import { Button } from "igniteui-react-inputs";
import { Icon } from "igniteui-react-inputs";
import { stringFormat } from "igniteui-react-core";
import { stringEmpty } from "igniteui-react-core";
/**
 * @hidden
 */
var MultiColumnComboBoxUtilities = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(MultiColumnComboBoxUtilities, _super);
    function MultiColumnComboBoxUtilities() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MultiColumnComboBoxUtilities.a = function (a, b, c, d, e, f, g, h) {
        var i = a.createElement("div");
        var j = a.getSubRenderer(i);
        g = new Button();
        g.provideContainer(j);
        g.r = c;
        g.h = d;
        g.d = e;
        var k = a.createElement("div");
        k.setStyleProperty("display", "inline-block");
        h = new Icon();
        var l = a.getSubRenderer(k);
        h.provideContainer(l);
        h.svgPath = b;
        k.setStyleProperty("width", stringFormat("{0}px", f.width.toString()));
        k.setStyleProperty("height", stringFormat("{0}px", f.height.toString()));
        var m = a.createElement("div");
        m.setStyleProperty("display", "flex");
        m.setStyleProperty("flex-direction", "row");
        m.setStyleProperty("flex-wrap", "no-wrap");
        m.setStyleProperty("align-items", "center");
        m.append(k);
        g.appendButtonContent(m);
        return {
            ret: i,
            p6: g,
            p7: h
        };
    };
    MultiColumnComboBoxUtilities.d = function (a) {
        var b = 0;
        if (a.altKey) {
            b |= 1;
        }
        if (a.shiftKey) {
            b |= 4;
        }
        if (a.ctrlKey) {
            b |= 2;
        }
        return b;
    };
    MultiColumnComboBoxUtilities.c = function (a, b, c) {
        if (c === void 0) {
            c = "block";
        }
        var d = b ? c : "none";
        a.setStyleProperty("display", d);
    };
    MultiColumnComboBoxUtilities.e = function (a, b, c) {
        if (null == MultiColumnComboBoxUtilities.b) {
            MultiColumnComboBoxUtilities.b = a.createElement("div");
            MultiColumnComboBoxUtilities.b.setStyleProperty("height", "auto");
            MultiColumnComboBoxUtilities.b.setStyleProperty("width", "auto");
            MultiColumnComboBoxUtilities.b.setStyleProperty("white-space", "nowrap");
            MultiColumnComboBoxUtilities.b.setStyleProperty("position", "absolute");
        }
        if (null != c) {
            MultiColumnComboBoxUtilities.b.setStyleProperty("font", c.fontString);
        }
        else {
            MultiColumnComboBoxUtilities.b.setStyleProperty("font", stringEmpty());
        }
        var d = MultiColumnComboBoxUtilities.b.getNativeElement();
        document.body.appendChild(d);
        MultiColumnComboBoxUtilities.b.setRawText(b);
        var e = MultiColumnComboBoxUtilities.b.outerWidth();
        var f = MultiColumnComboBoxUtilities.b.outerHeight();
        document.body.removeChild(d);
        return new Size(1, e, f);
    };
    MultiColumnComboBoxUtilities.$t = markType(MultiColumnComboBoxUtilities, 'MultiColumnComboBoxUtilities');
    MultiColumnComboBoxUtilities.b = null;
    return MultiColumnComboBoxUtilities;
}(Base));
export { MultiColumnComboBoxUtilities };
//# sourceMappingURL=MultiColumnComboBoxUtilities.js.map
